import { createAction } from "redux-actions";

import {
  CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES,
  CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES,
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
  CLEAR_WATCH_LIST_ENTRIES,
  CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES,
} from "../types";

export const clearWatchListEntries = createAction(CLEAR_WATCH_LIST_ENTRIES);

export const clearWatchListMultipleSearchEntries = createAction(CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES);

export const changeItemsPerPageWatchListEntries = createAction(
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES
);

export const changeItemsPerPageWatchListMultipleSearchEntries = createAction(
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES
);

export const changeCurrentPageWatchListEntries = createAction(
  CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES
);
export const changeCurrentPageWatchListMultipleSearchEntries = createAction(
  CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/clearWatchListEntryActions.js